import { render, staticRenderFns } from "./back-shelves.vue?vue&type=template&id=2fb5c5bc&"
import script from "./back-shelves.vue?vue&type=script&lang=ts&"
export * from "./back-shelves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports